import {useConfig} from '@aboutyou/config';
import {
  SkeletonBlock,
  SPACING,
  tabletAndUpLinaria,
} from '@aboutyou/ui-components';
import {range} from '@aboutyou/utils';
import React from 'react';
import styled from 'styled-components';
import {
  heroImageHeight,
  StoriesWrapper,
  StyledHeightCalcWrapper,
} from './Shared';

export const StoryClusterPageSkeleton = () => {
  const isMobile = useConfig().device === 'mobile';

  return (
    <section>
      <StyledHeightCalcWrapper>
        <HeroImageSkeleton />
      </StyledHeightCalcWrapper>

      {isMobile && (
        <div
          style={{
            margin: `${SPACING['X.Xl']} ${SPACING['X.Lg']}`,
          }}
        >
          <SublineSkeleton />
        </div>
      )}

      <StoriesWrapper>
        {range(0, 5).map((_, index) => (
          <StorySkeletonWrapper key={`skeleton-${index}`}>
            <StoryTileSkeleton $width="100%" $height="100%" />
            <SkeletonBlock
              $width="30%"
              $height="18px"
              style={{marginBottom: 4}}
            />
            <SkeletonBlock $width="60%" $height="20px" style={{margin: 0}} />
          </StorySkeletonWrapper>
        ))}
      </StoriesWrapper>
    </section>
  );
};

const StorySkeletonWrapper = styled.div`
  display: flex;
  flex-direction: column;
`;

const SublineSkeleton = styled(SkeletonBlock)`
  && {
    display: block;
    text-align: center;
    width: 42%;
    height: 16px;
    justify-self: center;
  }
`;

const HeroImageSkeleton = styled(SkeletonBlock)`
  && {
    height: 100%;
    margin-bottom: 0;
    width: 100%;
    aspect-ratio: 1.25 / 1;

    ${tabletAndUpLinaria(`
      aspect-ratio: unset;
      
      ${heroImageHeight}
    `)}
  }
`;

const StoryTileSkeleton = styled(SkeletonBlock)`
  && {
    aspect-ratio: 2.22 / 1;
    margin-bottom: 16px;
    border-radius: 8px;
    height: 100%;
  }
`;
